//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.PmiSemanticData.js";
let d=[[[0,"Category",0,0],[0,"CoordinateSystem",0,"CoordinateSystem",0],[0,"DecimalPlaces",0,0],[0,"IPrefix",0,0],[0,"ISuffix",0,0],[0,"IncludeI",0,0],[0,"IncludeJ",0,0],[0,"IncludeK",0,0],[0,"IncludeLabel",0,0],[0,"IncludeLevel",0,0],[0,"IncludeX",0,0],[0,"IncludeY",0,0],[0,"IncludeZ",0,0],[0,"JPrefix",0,0],[0,"JSuffix",0,0],[0,"KPrefix",0,0],[0,"KSuffix",0,0],[0,"LabelPrefix",0,0],[0,"LabelSuffix",0,0],[0,"LevelPrefix",0,0],[0,"LevelSuffix",0,0],[0,"Revision",0,0],[0,"Title",0,0],[0,"TrackedObject",0,"NXObject",0],[0,"XPrefix",0,0],[0,"XSuffix",0,0],[0,"YPrefix",0,0],[0,"YSuffix",0,0],[0,"ZPrefix",0,0],[0,"ZSuffix",0,0]],[],[]];
SPLM.Annotations.PmiCoordinateNoteData = class extends SPLM.Annotations.PmiSemanticData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiCoordinateNoteData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;